const caseExports = {
  getAvailableExports(id) {
    return `/homeowner/cases/${id}/export/available`;
  },
  getExportResults(id) {
    return `/homeowner/cases/${id}/export/results`;
  },
  startExport(id) {
    return `/homeowner/cases/${id}/export/start`;    
  },
  retryExport(id) {
    return `/homeowner/cases/${id}/export/retry`;      
  }
};

export default caseExports;
